import app from 'flarum/common/app';
import flag from 'country-code-emoji';
import convert from 'twemoji-basename';

export default (countryCode) => {
  try {
    const codepoint = flag(countryCode);
    if (codepoint) {
      const basename = convert(codepoint);
      return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14/assets/72x72/${basename}.png`;
    }
  } catch {}
  return app.forum.attribute('assetsBaseUrl') + '/extensions/fof-geoip/unknown_flag.png';
};
